import { isDefined, clone, mergeWithoutArray, mergeIn, getIn, setIn, deleteIn, hasValue, isEqual, allValuesHasValue, hasValueIn, isTruthy, isTruthyIn } from '@uiux/fn';
import { Subject, ObjectUnsubscribedError, pipe, Observable, timer, defer, throwError, concat } from 'rxjs';
import { map, distinctUntilChanged, mergeMap, filter, take, timeoutWith, retryWhen, delay } from 'rxjs/operators';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/subjects/behavior-defined-subject.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
class BehaviorDefinedSubject extends Subject {
    /**
     * @param {?=} initialValue
     */
    constructor(initialValue) {
        super();
        if (isDefined(initialValue)) {
            this._value = initialValue;
        }
    }
    /**
     * @return {?}
     */
    get value() {
        return this.getValue();
    }
    /**
     * @param {?} subscriber
     * @return {?}
     */
    _subscribe(subscriber) {
        // tslint:disable-next-line
        /** @type {?} */
        const subscription = super._subscribe(subscriber);
        if (subscription && !((/** @type {?} */ (subscription))).closed && isDefined(this._value)) {
            subscriber.next(this._value);
        }
        return subscription;
    }
    /**
     * @return {?}
     */
    getValue() {
        if (this.hasError) {
            throw this.thrownError;
        }
        else if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        else {
            return this._value;
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    next(value) {
        if (isDefined(value)) {
            this._value = clone(value);
            super.next(this._value);
        }
    }
    /**
     * Does not publish value.
     * @param {?} val
     * @param {?=} publish
     * @return {?}
     */
    setValue(val, publish = true) {
        this._value = clone(val);
        if (publish) {
            this.publish();
        }
    }
    /**
     * @param {?} val
     * @param {?=} publish
     * @return {?}
     */
    merge(val, publish = true) {
        this._value = mergeWithoutArray(this._value, clone(val));
        if (publish) {
            this.publish();
        }
    }
    /**
     * @param {?} keys
     * @param {?} value
     * @param {?=} publish
     * @return {?}
     */
    mergeIn(keys, value, publish = true) {
        this._value = mergeIn(this._value, keys, clone(value));
        if (publish) {
            this.publish();
        }
    }
    /**
     * Only works for objects, of course.
     * @param {?} key
     * @param {?} val
     * @param {?=} publish
     * @return {?}
     */
    setValueByKey(key, val, publish = true) {
        this._value[key] = clone(val);
        if (publish) {
            this.publish();
        }
    }
    /**
     * @param {?} key
     * @return {?}
     */
    getValueByKey(key) {
        return this._value[key];
    }
    /**
     * @param {?} key
     * @return {?}
     */
    getIn(key) {
        return getIn(this._value, key);
    }
    /**
     * @param {?} key
     * @param {?} val
     * @param {?=} publish
     * @return {?}
     */
    setIn(key, val, publish = true) {
        setIn(this._value, key, clone(val));
        if (publish) {
            this.publish();
        }
    }
    /**
     * Delete object or array in stored value
     * @param {?} key
     * @param {?=} publish
     * @return {?}
     */
    deleteIn(key, publish = true) {
        this._value = deleteIn(this._value, key);
        if (publish) {
            this.publish();
        }
    }
    /**
     *
     * @param {?} key
     * @param {?=} publish
     * @return {?}
     */
    nullKey(key, publish = true) {
        this._value[key] = null;
        if (publish) {
            this.publish();
        }
    }
    /**
     *
     * @param {?} key
     * @param {?=} publish
     * @return {?}
     */
    undefineKey(key, publish = true) {
        this._value[key] = undefined;
        if (publish) {
            this.publish();
        }
    }
    /**
     *
     * @param {?} key
     * @param {?=} publish
     * @return {?}
     */
    nullIn(key, publish = true) {
        setIn(this._value, key, null);
        if (publish) {
            this.publish();
        }
    }
    /**
     *
     * @param {?} key
     * @param {?=} publish
     * @return {?}
     */
    undefineIn(key, publish = true) {
        setIn(this._value, key, undefined);
        if (publish) {
            this.publish();
        }
    }
    /**
     * @return {?}
     */
    publish() {
        this.next(this._value);
    }
}
if (false) {
    /**
     * @type {?}
     * @private
     */
    BehaviorDefinedSubject.prototype._value;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/subjects/behavior-store-subject.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
class BehaviorStoreSubject extends Subject {
    /**
     * @param {?} _value
     */
    constructor(_value) {
        super();
        this._value = _value;
    }
    /**
     * @return {?}
     */
    get value() {
        return this.getValue();
    }
    /**
     * @param {?} subscriber
     * @return {?}
     */
    _subscribe(subscriber) {
        // tslint:disable-next-line
        /** @type {?} */
        const subscription = super._subscribe(subscriber);
        if (subscription && !((/** @type {?} */ (subscription))).closed) {
            subscriber.next(this._value);
        }
        return subscription;
    }
    /**
     * @return {?}
     */
    getValue() {
        if (this.hasError) {
            throw this.thrownError;
        }
        else if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        else {
            return this._value;
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    next(value) {
        this._value = clone(value);
        super.next(this._value);
    }
    /**
     * Does not publish value.
     * @param {?} val
     * @param {?=} publish
     * @return {?}
     */
    setValue(val, publish = true) {
        this._value = clone(val);
        if (publish) {
            this.publish();
        }
    }
    /**
     * @param {?} val
     * @param {?=} publish
     * @return {?}
     */
    merge(val, publish = true) {
        this._value = mergeWithoutArray(this._value, clone(val));
        if (publish) {
            this.publish();
        }
    }
    /**
     * @param {?} keys
     * @param {?} value
     * @param {?=} publish
     * @return {?}
     */
    mergeIn(keys, value, publish = true) {
        this._value = mergeIn(this._value, keys, clone(value));
        if (publish) {
            this.publish();
        }
    }
    /**
     * Only works for objects, of course.
     * @param {?} key
     * @param {?} val
     * @param {?=} publish
     * @return {?}
     */
    setValueByKey(key, val, publish = true) {
        this._value[key] = clone(val);
        if (publish) {
            this.publish();
        }
    }
    /**
     * @param {?} key
     * @return {?}
     */
    getValueByKey(key) {
        return this._value[key];
    }
    /**
     * @param {?} key
     * @return {?}
     */
    getIn(key) {
        return getIn(this._value, key);
    }
    /**
     * @param {?} key
     * @param {?} val
     * @param {?=} publish
     * @return {?}
     */
    setIn(key, val, publish = true) {
        setIn(this._value, key, clone(val));
        if (publish) {
            this.publish();
        }
    }
    /**
     * Delete object or array in stored value
     * @param {?} key
     * @param {?=} publish
     * @return {?}
     */
    deleteIn(key, publish = true) {
        this._value = deleteIn(this._value, key);
        if (publish) {
            this.publish();
        }
    }
    /**
     *
     * @param {?} key
     * @param {?=} publish
     * @return {?}
     */
    nullKey(key, publish = true) {
        this._value[key] = null;
        if (publish) {
            this.publish();
        }
    }
    /**
     *
     * @param {?} key
     * @param {?=} publish
     * @return {?}
     */
    undefineKey(key, publish = true) {
        this._value[key] = undefined;
        if (publish) {
            this.publish();
        }
    }
    /**
     *
     * @param {?} key
     * @param {?=} publish
     * @return {?}
     */
    nullIn(key, publish = true) {
        setIn(this._value, key, null);
        if (publish) {
            this.publish();
        }
    }
    /**
     *
     * @param {?} key
     * @param {?=} publish
     * @return {?}
     */
    undefineIn(key, publish = true) {
        setIn(this._value, key, undefined);
        if (publish) {
            this.publish();
        }
    }
    /**
     * @return {?}
     */
    publish() {
        this.next(this._value);
    }
}
if (false) {
    /**
     * @type {?}
     * @private
     */
    BehaviorStoreSubject.prototype._value;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/subjects/behavior-value-subject.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
class BehaviorValueSubject extends Subject {
    /**
     * @param {?=} initialValue
     */
    constructor(initialValue) {
        super();
        if (hasValue(initialValue)) {
            this._value = initialValue;
        }
    }
    /**
     * @return {?}
     */
    get value() {
        return this.getValue();
    }
    /**
     * @param {?} subscriber
     * @return {?}
     */
    _subscribe(subscriber) {
        // tslint:disable-next-line
        /** @type {?} */
        const subscription = super._subscribe(subscriber);
        if (subscription && !((/** @type {?} */ (subscription))).closed && hasValue(this._value)) {
            subscriber.next(this._value);
        }
        return subscription;
    }
    /**
     * @return {?}
     */
    getValue() {
        if (this.hasError) {
            throw this.thrownError;
        }
        else if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        else {
            return this._value;
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    next(value) {
        if (hasValue(value)) {
            this._value = clone(value);
            super.next(this._value);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    nextDefined(value) {
        if (isDefined(value)) {
            this._value = clone(value);
            super.next(this._value);
        }
    }
    /**
     * Does not publish value.
     * @param {?} val
     * @param {?=} publish
     * @return {?}
     */
    setValue(val, publish = true) {
        this._value = clone(val);
        if (publish) {
            this.publish();
        }
    }
    /**
     * @param {?} val
     * @param {?=} publish
     * @return {?}
     */
    merge(val, publish = true) {
        this._value = mergeWithoutArray(this._value, clone(val));
        if (publish) {
            this.publish();
        }
    }
    /**
     * @param {?} keys
     * @param {?} value
     * @param {?=} publish
     * @return {?}
     */
    mergeIn(keys, value, publish = true) {
        this._value = mergeIn(this._value, keys, clone(value));
        if (publish) {
            this.publish();
        }
    }
    /**
     * Only works for objects, of course.
     * @param {?} key
     * @param {?} val
     * @param {?=} publish
     * @return {?}
     */
    setValueByKey(key, val, publish = true) {
        this._value[key] = clone(val);
        if (publish) {
            this.publish();
        }
    }
    /**
     * @param {?} key
     * @return {?}
     */
    getValueByKey(key) {
        return this._value[key];
    }
    /**
     * @param {?} key
     * @return {?}
     */
    getIn(key) {
        return getIn(this._value, key);
    }
    /**
     * @param {?} key
     * @param {?} val
     * @param {?=} publish
     * @return {?}
     */
    setIn(key, val, publish = true) {
        setIn(this._value, key, clone(val));
        if (publish) {
            this.publish();
        }
    }
    /**
     * Delete object or array in stored value
     * @param {?} key
     * @param {?=} publish
     * @return {?}
     */
    deleteIn(key, publish = true) {
        this._value = deleteIn(this._value, key);
        if (publish) {
            this.publish();
        }
    }
    /**
     *
     * @param {?} key
     * @param {?=} publish
     * @return {?}
     */
    nullKey(key, publish = true) {
        this._value[key] = null;
        if (publish) {
            this.publish();
        }
    }
    /**
     *
     * @param {?} key
     * @param {?=} publish
     * @return {?}
     */
    undefineKey(key, publish = true) {
        this._value[key] = undefined;
        if (publish) {
            this.publish();
        }
    }
    /**
     *
     * @param {?} key
     * @param {?=} publish
     * @return {?}
     */
    nullIn(key, publish = true) {
        setIn(this._value, key, null);
        if (publish) {
            this.publish();
        }
    }
    /**
     *
     * @param {?} key
     * @param {?=} publish
     * @return {?}
     */
    undefineIn(key, publish = true) {
        setIn(this._value, key, undefined);
        if (publish) {
            this.publish();
        }
    }
    /**
     * @return {?}
     */
    publish() {
        this.next(this._value);
    }
}
if (false) {
    /**
     * @type {?}
     * @private
     */
    BehaviorValueSubject.prototype._value;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/subjects/distinct-subject.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
class DistinctSubject extends Subject {
    /**
     * @param {?} _previousValue
     * @param {?=} key
     */
    constructor(_previousValue, key) {
        super();
        this._previousValue = _previousValue;
        this.key = key;
        this._isDistinct = false;
    }
    /**
     * @return {?}
     */
    get value() {
        return this.getValue();
    }
    /**
     * @param {?} subscriber
     * @return {?}
     */
    _subscribe(subscriber) {
        // tslint:disable-next-line
        /** @type {?} */
        const subscription = super._subscribe(subscriber);
        if (subscription && !((/** @type {?} */ (subscription))).closed) {
            subscriber.next(this._previousValue);
        }
        return subscription;
    }
    /**
     * @return {?}
     */
    getValue() {
        if (this.hasError) {
            throw this.thrownError;
        }
        else if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        else {
            return this._previousValue;
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    next(value) {
        if (this.key && hasValue(this.key)) {
            if (hasValue(this._previousValue)) {
                this._isDistinct = getIn(value, this.key) !== getIn(this._previousValue, this.key);
                if (this._isDistinct) {
                    this._previousValue = value;
                    super.next((this._previousValue = value));
                }
            }
            else {
                this._isDistinct = true;
                this._previousValue = value;
                super.next((this._previousValue = value));
            }
        }
        else {
            this._isDistinct = isEqual(value, this._previousValue) !== true;
            if (this._isDistinct) {
                this._previousValue = value;
                super.next((this._previousValue = value));
            }
        }
        return this._isDistinct;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    isDistinct(value) {
        return this.next(value);
    }
    /**
     * Does not publish value.
     * @param {?} val
     * @return {?}
     */
    setValue(val) {
        this._previousValue = val;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    merge(val) {
        this._previousValue = mergeWithoutArray(this._previousValue, val);
    }
    /**
     * @param {?} val
     * @return {?}
     */
    mergeNext(val) {
        this.merge(val);
        this.publish();
    }
    /**
     * Only works for objects, of course.
     * @param {?} key
     * @param {?} val
     * @return {?}
     */
    setValueByKey(key, val) {
        this._previousValue[key] = val;
    }
    /**
     * @param {?} key
     * @param {?} val
     * @return {?}
     */
    setValueByKeyNext(key, val) {
        this.setValueByKey(key, val);
        this.publish();
    }
    /**
     * @return {?}
     */
    publish() {
        this.next(this._previousValue);
    }
}
if (false) {
    /**
     * @type {?}
     * @private
     */
    DistinctSubject.prototype._isDistinct;
    /**
     * @type {?}
     * @private
     */
    DistinctSubject.prototype._previousValue;
    /**
     * @type {?}
     * @private
     */
    DistinctSubject.prototype.key;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/subjects/fork-join-subject.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
class ForkJoinSubject extends Subject {
    /**
     * @param {?} _structure
     */
    constructor(_structure) {
        super();
        this._structure = _structure;
        this._isPublished = false;
    }
    /**
     * @return {?}
     */
    get value() {
        return this.getValue();
    }
    /**
     * @param {?} subscriber
     * @return {?}
     */
    _subscribe(subscriber) {
        // tslint:disable-next-line
        /** @type {?} */
        const subscription = super._subscribe(subscriber);
        if (subscription && !((/** @type {?} */ (subscription))).closed && allValuesHasValue(this._structure)) {
            subscriber.next(this._structure);
        }
        return subscription;
    }
    /**
     * @return {?}
     */
    getValue() {
        if (this.hasError) {
            throw this.thrownError;
        }
        else if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        else {
            return this._structure;
        }
    }
    /**
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    nextKey(key, value) {
        this._structure[key] = value;
        this._next(this._structure);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    merge(value) {
        this._structure = mergeWithoutArray(this._structure, value);
        this._next(this._structure);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    next(value) {
        this._structure = mergeWithoutArray(this._structure, value);
        this._next(this._structure);
    }
    /**
     * Does not publish value.
     * @param {?} val
     * @return {?}
     */
    setValue(val) {
        this._structure = val;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    mergeNext(val) {
        this.merge(val);
        this.publish();
    }
    /**
     * Only works for objects, of course.
     * @param {?} key
     * @param {?} val
     * @return {?}
     */
    setValueByKey(key, val) {
        this._structure[key] = val;
    }
    /**
     * @param {?} key
     * @param {?} val
     * @return {?}
     */
    setValueByKeyNext(key, val) {
        this.setValueByKey(key, val);
        this.publish();
    }
    /**
     * @return {?}
     */
    publish() {
        this.next(this._structure);
    }
    /**
     * @private
     * @param {?} value
     * @return {?}
     */
    _next(value) {
        if (!this._isPublished && allValuesHasValue(this._structure)) {
            this._isPublished = true;
            super.next(value);
            super.complete();
        }
    }
}
if (false) {
    /**
     * @type {?}
     * @private
     */
    ForkJoinSubject.prototype._isPublished;
    /**
     * @type {?}
     * @private
     */
    ForkJoinSubject.prototype._structure;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/clone-pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 * @return {?}
 */
function clonePipe() {
    return map((/**
     * @param {?} d
     * @return {?}
     */
    (d) => {
        try {
            return clone(d);
        }
        catch (e) {
            return d;
        }
    }));
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/distinct-until-json-changed.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 * @return {?}
 */
function distinctUntilJsonChanged() {
    return pipe(map((/**
     * @param {?} d
     * @return {?}
     */
    (d) => {
        try {
            return JSON.stringify(d);
        }
        catch (e) {
            console.error('distinctUntilJsonChanged not able to JSON.stringify data');
            return d;
        }
    })), distinctUntilChanged(), map((/**
     * @param {?} d
     * @return {?}
     */
    (d) => {
        if (typeof d === 'string') {
            return JSON.parse(d);
        }
        // data was never stringified
        return d;
    })));
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/has-value-pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T, K
 * @return {?}
 */
function hasValuePipe() {
    return (/**
     * @param {?} source
     * @return {?}
     */
    (source) => {
        return new Observable((/**
         * @param {?} observer
         * @return {?}
         */
        (observer) => {
            return source.subscribe({
                /**
                 * @param {?} x
                 * @return {?}
                 */
                next(x) {
                    if (hasValue(x)) {
                        observer.next(x);
                    }
                },
                /**
                 * @param {?} err
                 * @return {?}
                 */
                error(err) {
                    observer.error(err);
                },
                /**
                 * @return {?}
                 */
                complete() {
                    observer.complete();
                },
            });
        }));
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/has-value-in-pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T, K
 * @param {?} keys
 * @return {?}
 */
function hasValueInPipe(keys) {
    return (/**
     * @param {?} source
     * @return {?}
     */
    (source) => {
        return new Observable((/**
         * @param {?} observer
         * @return {?}
         */
        (observer) => {
            return source.subscribe({
                /**
                 * @param {?} x
                 * @return {?}
                 */
                next(x) {
                    if (hasValueIn(x, keys)) {
                        observer.next(x);
                    }
                },
                /**
                 * @param {?} err
                 * @return {?}
                 */
                error(err) {
                    observer.error(err);
                },
                /**
                 * @return {?}
                 */
                complete() {
                    observer.complete();
                },
            });
        }));
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/is-defined-pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T, K
 * @return {?}
 */
function isDefinedPipe() {
    return (/**
     * @param {?} source
     * @return {?}
     */
    (source) => {
        return new Observable((/**
         * @param {?} observer
         * @return {?}
         */
        (observer) => {
            return source.subscribe({
                /**
                 * @param {?} x
                 * @return {?}
                 */
                next(x) {
                    if (isDefined(x)) {
                        observer.next(x);
                    }
                },
                /**
                 * @param {?} err
                 * @return {?}
                 */
                error(err) {
                    observer.error(err);
                },
                /**
                 * @return {?}
                 */
                complete() {
                    observer.complete();
                },
            });
        }));
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/is-truthy-pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 * @return {?}
 */
function isTruthyPipe() {
    return (/**
     * @param {?} source
     * @return {?}
     */
    (source) => {
        return new Observable((/**
         * @param {?} observer
         * @return {?}
         */
        (observer) => {
            return source.subscribe({
                /**
                 * @param {?} x
                 * @return {?}
                 */
                next(x) {
                    if (isTruthy(x)) {
                        observer.next(x);
                    }
                },
                /**
                 * @param {?} err
                 * @return {?}
                 */
                error(err) {
                    observer.error(err);
                },
                /**
                 * @return {?}
                 */
                complete() {
                    observer.complete();
                },
            });
        }));
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/is-truthy-in-pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 * @param {?} keys
 * @return {?}
 */
function isTruthyInPipe(keys) {
    return (/**
     * @param {?} source
     * @return {?}
     */
    (source) => {
        return new Observable((/**
         * @param {?} observer
         * @return {?}
         */
        (observer) => {
            return source.subscribe({
                /**
                 * @param {?} x
                 * @return {?}
                 */
                next(x) {
                    if (isTruthyIn(x, keys)) {
                        observer.next(x);
                    }
                },
                /**
                 * @param {?} err
                 * @return {?}
                 */
                error(err) {
                    observer.error(err);
                },
                /**
                 * @return {?}
                 */
                complete() {
                    observer.complete();
                },
            });
        }));
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/not-null-or-undefined-pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 * @return {?}
 */
function notNullOrUndefinedPipe() {
    return (/**
     * @param {?} source
     * @return {?}
     */
    (source) => {
        return new Observable((/**
         * @param {?} observer
         * @return {?}
         */
        (observer) => {
            return source.subscribe({
                /**
                 * @param {?} x
                 * @return {?}
                 */
                next(x) {
                    if (x !== null && x !== undefined) {
                        observer.next(x);
                    }
                },
                /**
                 * @param {?} err
                 * @return {?}
                 */
                error(err) {
                    observer.error(err);
                },
                /**
                 * @return {?}
                 */
                complete() {
                    observer.complete();
                },
            });
        }));
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/poll-for-value-pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IPollForValueConfig() { }
if (false) {
    /** @type {?} */
    IPollForValueConfig.prototype.delay;
    /** @type {?} */
    IPollForValueConfig.prototype.interval;
    /** @type {?} */
    IPollForValueConfig.prototype.timeout;
    /** @type {?} */
    IPollForValueConfig.prototype.sourceObservable;
    /** @type {?|undefined} */
    IPollForValueConfig.prototype.compare;
    /** @type {?|undefined} */
    IPollForValueConfig.prototype.errorMsg;
    /** @type {?|undefined} */
    IPollForValueConfig.prototype.schedular;
}
/**
 * @param {?} config
 * @return {?}
 */
function pollForValueWithConfig(config) {
    return pollForValue(config.delay, config.interval, config.timeout, config.sourceObservable, config.compare, config.errorMsg, config.schedular);
}
/**
 * @param {?} _delay
 * @param {?} _interval
 * @param {?} _timeout
 * @param {?} _sourceObservable
 * @param {?=} _compare
 * @param {?=} _errorMsg
 * @param {?=} _schedular
 * @return {?}
 */
function pollForValue(_delay, _interval, _timeout, _sourceObservable, _compare, _errorMsg, _schedular) {
    /** @type {?} */
    const errorMsg = _errorMsg ? _errorMsg : 'Poll Timeout';
    /**
     * source is the Observable you created passed into this (pollForValue) function.
     *
     * For example:
     * from([1, 2, 3]).pipe( pollForValue( ... ) ).subscribe( ... )
     *
     * The observable emitting [1, 2, 3] is the source observable.
     */
    return (/**
     * @template T
     * @param {?} source
     * @return {?}
     */
    (source) => {
        /**
         * Wrapper Observable that creates and observer ( has next, error, and complete
         * functions ). The observer is used to pass values once the poll is complete
         */
        return new Observable((/**
         * @param {?} observer
         * @return {?}
         */
        (observer) => {
            /**
             * Iteration on source observer
             */
            return source
                .pipe(
            /**
             * Look at every value published by source observable
             */
            mergeMap((/**
             * @param {?} _initialValue
             * @return {?}
             */
            (_initialValue) => {
                /**
                 * Call the function passed in by the config, if available,
                 * to test is the source value ( _initialValue ) is
                 * what you are looking for.
                 *
                 * Test the value with a compare function ( if provided )
                 * to see if it matches the criteria for a desired value.
                 *
                 * If test fails, start polling.
                 */
                if (_compare && _compare(_initialValue)) {
                    return [_initialValue];
                }
                else {
                    /**
                     * Set up and interval timer that starts
                     * after a delay time.
                     */
                    return timer(_delay, _interval).pipe(
                    /**
                     * After the delay or interval, call the source
                     * observable again to get an updated value.
                     */
                    mergeMap((/**
                     * @return {?}
                     */
                    () => {
                        return _sourceObservable();
                    })), 
                    /**
                     * Test the returned value again for
                     * desired criteria with a compare function
                     * if provided.
                     *
                     * If not compare function is provided,
                     * pass value to next step.
                     */
                    filter((/**
                     * @param {?} _data
                     * @return {?}
                     */
                    (_data) => {
                        if (_compare) {
                            return _compare(_data);
                        }
                        else {
                            return true;
                        }
                    })), 
                    /**
                     * Only take the first returned value
                     * from the retried source observable.
                     *
                     * We only care if the returned value exists or not.
                     */
                    take(1), 
                    /**
                     * If, after designated timeout time there is not
                     * value, throw and error.
                     */
                    timeoutWith(_timeout, defer((/**
                     * @return {?}
                     */
                    () => {
                        return throwError(new Error(errorMsg));
                    })), _schedular));
                }
            }))
            /**
             * Subscribe to the source observable to start
             * the polling process.
             *
             * Return value using the generated observer.
             */
            )
                .subscribe({
                /**
                 * @param {?} x
                 * @return {?}
                 */
                next(x) {
                    observer.next(x);
                },
                /**
                 * @param {?} err
                 * @return {?}
                 */
                error(err) {
                    observer.error(err);
                },
                /**
                 * @return {?}
                 */
                complete() {
                    observer.complete();
                },
            });
        }));
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/poll-when-error-pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IPollWhenErrorConfig() { }
if (false) {
    /** @type {?} */
    IPollWhenErrorConfig.prototype.delay;
    /** @type {?} */
    IPollWhenErrorConfig.prototype.take;
    /** @type {?|undefined} */
    IPollWhenErrorConfig.prototype.errorMsg;
}
// tslint:disable-next-line
/**
 * @param {?} config
 * @return {?}
 */
function pollWhenErrorWithConfig(config) {
    return pollWhenError(config.delay, config.take, config.errorMsg);
}
/**
 * @param {?} _delay
 * @param {?} _take
 * @param {?=} _errorMsg
 * @return {?}
 */
function pollWhenError(_delay, _take, _errorMsg) {
    /** @type {?} */
    const errorMsg = _errorMsg ? _errorMsg : 'Error poll timed out.';
    /**
     * source observable created passed into this function.
     */
    return (/**
     * @template T
     * @param {?} source
     * @return {?}
     */
    (source) => {
        /**
         * Return a new observable.
         */
        return new Observable((/**
         * @param {?} observer
         * @return {?}
         */
        (observer) => {
            source
                .pipe(retryWhen((/**
             * @param {?} errors
             * @return {?}
             */
            (errors) => {
                return concat(errors.pipe(delay(_delay), take(_take)), throwError(new Error(errorMsg)));
            })))
                .subscribe({
                /**
                 * @param {?} x
                 * @return {?}
                 */
                next(x) {
                    observer.next(x);
                },
                /**
                 * @param {?} err
                 * @return {?}
                 */
                error(err) {
                    observer.error(err);
                },
                /**
                 * @return {?}
                 */
                complete() {
                    observer.complete();
                },
            });
        }));
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: uiux-rxjs.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { BehaviorDefinedSubject, BehaviorStoreSubject, BehaviorValueSubject, DistinctSubject, ForkJoinSubject, clonePipe, distinctUntilJsonChanged, hasValueInPipe, hasValuePipe, isDefinedPipe, isTruthyInPipe, isTruthyPipe, notNullOrUndefinedPipe, pollForValue, pollForValueWithConfig, pollWhenError, pollWhenErrorWithConfig };

